import {
  AccordionContent,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from "@/components/ui/Accordion";
import { MegaMenuSectionStoryblok } from "@/generated/sb/sb-types";
import { Link } from "@/i18n/routing";
import { getLink } from "@frend-digital/storyblok";
import styles from "../../index.module.css";

type MobileMenuModalProps = {
  link: MegaMenuSectionStoryblok;
};

const MobileMenuModal = ({ link }: MobileMenuModalProps) => {
  const href = getLink(link.link)?.href;

  const isNestedSection =
    link.component === "megaMenuSection" && link?.links?.length;
  return (
    <>
      {isNestedSection ? (
        <AccordionRoot>
          <AccordionItem className={styles.accordionItem}>
            <AccordionTrigger
              className={styles.accordionTrigger}
              mobileMenu={true}
            >
              {link.text}
            </AccordionTrigger>
            <AccordionContent className={styles.accordionContent}>
              {link.links?.map((subLink) => {
                const href = getLink(subLink.link)?.href;
                return (
                  <div key={subLink._uid}>
                    <Link href={href ?? ""}>{subLink.text}</Link>
                  </div>
                );
              })}
            </AccordionContent>
          </AccordionItem>
        </AccordionRoot>
      ) : (
        <Link href={href ?? ""}>{link.text}</Link>
      )}
    </>
  );
};

export default MobileMenuModal;
